import { environ } from "@ihr-radioedit/sdk-utils";
import { PWSMediaGraphQLService } from "@inferno/renderer-shared-core";

export const coastMediaService = new PWSMediaGraphQLService(
  environ.dep("webapi"),
  "coast-pr",
  undefined,
  environ.dep("pws"),
);
